import styled from '@emotion/styled'
import { ROUTES } from 'parameters'
import { ErrorStateIcon } from '../icons'
import { LinkButton } from 'ui/inputs/Button/LinkButton'

export const ErrorState = (): JSX.Element => {
	return (
		<Container>
			{ErrorStateIcon}
			<Text>
				Hmm, we need more information to match you with personal loan options. Don&apos;t worry, it&apos;s fast, easy
				and free.
			</Text>
			<LinkButton variant="secondary" href={ROUTES.SEARCH}>
				Get Started
			</LinkButton>
		</Container>
	)
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border: 1px solid #bdc4c9;
	box-sizing: border-box;
	border-radius: 8px;
	padding: 24px;
	margin: 24px 0 24px 0;
	width: 100%;
	min-height: 328px;
`

const Text = styled.div`
	font-size: 18px;
	line-height: 148%;
	margin-top: 24px;
	margin-bottom: 16px;
	white-space: initial;
`
